"use strict";

var PropTypes = require('prop-types');

var template = require('./itemRowBase.jsx');

var displayNames = require('../displayNames');

var compose = require('../../hoc/compose');

var ItemRowBase = template;
ItemRowBase.displayName = displayNames.SORT_BY_DRAG_LIST_ITEM_ROW_BASE;
ItemRowBase.propTypes = {
  dragHandle: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dragHandleEnabled: PropTypes.bool,
  dragHandleTooltipContent: PropTypes.string,
  isDragging: PropTypes.bool
};
ItemRowBase.defaultProps = {
  dragHandle: true,
  dragHandleEnabled: true
};
module.exports = compose(ItemRowBase);